import { render, staticRenderFns } from "./modals-home.vue?vue&type=template&id=4fb8b62f"
import script from "./modals-home.vue?vue&type=script&lang=js"
export * from "./modals-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports